//  import "../index.css";
import { Navigate } from "react-router-dom";
import { useAuth } from "../auth/context";
import type { ReactNode } from "react";
// import { navigationUtils } from "../NavigationUtils";

interface EntryPointProps {
  children: ReactNode;
  path: string;
}

export default function EntryPoint({ children, path }: EntryPointProps) {
  const { user, loading, profileReady } = useAuth();

  if (loading || !profileReady) {
    return <div></div>;
  }

  // Not logged in - redirect to login
  if (!user) {
    return <Navigate to="/login" state={{ returnUrl: path }} replace />;
  }

  // Logged in but email not verified - redirect to verification page
  // Note: OAuth users (Google/Apple) are auto-verified, so this only affects email signups
  if (!user.emailVerified) {
    return <Navigate to="/verify-email" replace />;
  }

  // Logged in and verified - show the protected content
  return <>{children}</>;
}
